// removed by extract-text-webpack-plugin
module.exports = {"clientContractsZoomContainer":"_3cbJ0AdvwAmCNidyUWIx4x","moduleControls":"_1FpPailH-S4tgPMyWw4x76","buttonOrganizer":"_2WZ_z4DZAl-rLSIvPOS27y","backToList":"_1Zpc-Jv8D2tCJNbhxmUulq","moduleSection":"O9Cdw4avMqZkYLhW2-GYl","descLabel":"_1_a-e2I2F1pD1aj1sDtyUf","riskDescriptionContainer":"_27Zcmet3YSSIaDfpbqbQtg","riskDescLabel":"LgUuPemVcFeBdJzlrLPeS","riskDesc":"_3DM--Z3hWIuE1VsTUQJ2v9","clientsTableContainer":"U1hg0wjuFtmulllw3ExGt","wizardButtonCorrection":"wiG-lTgiluARRiK--RhHx"};


//////////////////
// WEBPACK FOOTER
// ./components/clients/clientContractsZoom.scss
// module id = 1599
// module chunks = 0